// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:49
import { ComjobArgs_abstract } from './../../abstract/SagaBase/Defines/ComjobArgs_abstract';
export class ComjobArgs extends ComjobArgs_abstract {}
